import { environment } from '@lla-platform/core/core-util'

export const SURVEY_API_URL = {
  surveyBase: (surveyId: string) => `${environment.apiUrl}/public/survey/${surveyId}`,
  adminGetSurveySummary: `${environment.apiUrl}/admin/survey-summary`,
  adminExportSurvey: (surveyId: string) => `${environment.apiUrl}/admin/survey-results/${surveyId}`
}
